module.exports = __webpack_public_path__ + "img/icon_footer_download_qrcode.14dc4cc3.png";